// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2fQxv","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1je9Q"};